import entityApiUrl from '../../entity/baseUrl'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import { AuditAction, AuditCategory, AuditPage } from './AuditEntry'

export type ListAuditParameters = {
  cursor?: string
  pageSize?: number
  category?: AuditCategory
  action?: AuditAction
  actor?: string
  targetId?: string
  from?: string
  to?: string
}

const listAudit = async (params: ListAuditParameters = {}): Promise<AuditPage> => {
  const search = new URLSearchParams()
  if (params.cursor) search.set('cursor', params.cursor)
  if (params.pageSize) search.set('pageSize', String(params.pageSize))
  if (params.category) search.set('category', params.category)
  if (params.action) search.set('action', params.action)
  if (params.actor) search.set('actor', params.actor)
  if (params.targetId) search.set('targetId', params.targetId)
  if (params.from) search.set('from', params.from)
  if (params.to) search.set('to', params.to)
  const query = search.toString()

  const response = await fetchAuthorized(
    (authContext) => `${entityApiUrl}/organizations/${authContext.organizationId}/audit${query ? `?${query}` : ''}`,
    { method: 'GET' }
  )
  if (response.status !== 200) throw new Error(`Unexpected response code ${response.status} from audit endpoint`)
  return (await response.json()) as AuditPage
}

export default listAudit
